import { ControlProperty } from '../../../../../../../common/models';
import { DriverIdType } from '../../../../../administration';

export class AllocationViewUliDriverInformationModel {
  frequentDriverId: number = null;
  firstName: string = null;
  lastName: string = null;
  permitNumber: string = null;
  permitType: DriverIdType = null;
  phoneNumber: string = null;
  loanerPhoneId: string = null;
  parkingSpaceId: string = null;
  remainingDrivingTime: number = null;
  nextBreakLength: number = null;
  signature: string;
  storeFrequentDriver = false;

  constructor(params?: AllocationViewUliDriverInformationModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewUliDriverInformationForm {
  constructor(
    model: AllocationViewUliDriverInformationModel,
    public frequentDriverId: ControlProperty<number> = model.frequentDriverId,
    public firstName: ControlProperty<string> = model.firstName,
    public lastName: ControlProperty<string> = model.lastName,
    public permitNumber: ControlProperty<string> = model.permitNumber,
    public permitType: ControlProperty<DriverIdType> = model.permitType,
    public phoneNumber: ControlProperty<string> = model.phoneNumber,
    public loanerPhoneId: ControlProperty<string> = model.loanerPhoneId,
    public parkingSpaceId: ControlProperty<string> = model.parkingSpaceId,
    public remainingDrivingTime: ControlProperty<number> = model.remainingDrivingTime,
    public nextBreakLength: ControlProperty<number> = model.nextBreakLength,
  ) {}
}
